import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'app/material.module';
import { RoleModule } from 'app/role/role.module';
import { UserProfileDialogComponent } from 'app/shared/components/user-profile-dialog/user-profile-dialog.component';
import { Base64DecodePipe } from 'app/shared/pipes/base64-decode.pipe';
import { SiteSettingsModule } from 'app/site-settings/site-settings.module';

import { AssessmentListItemComponent } from './components/assessment-list-item/assessment-list-item.component';
import { UserNameLinkComponent } from './components/user-name-link/user-name-link.component';
import { UserSelectItemComponent } from './components/user-select-item/user-select-item.component';
import { UserSelectComponent } from './components/user-select/user-select.component';
import { VarDirective } from './directives/ng-var.directive';
import { ArraySlicePipe } from './pipes/array-slice.pipe';
import { FilterDetailedUsersPipe } from './pipes/filter-detailed-users.pipe';
import { FilterNotificationTemplatesPipe } from './pipes/filter-notification-template.pipe';
import { FilterRecAssignedToPipe } from './pipes/filter-rec-asigned-to.pipe';
import { FilterSiteItemsPipe } from './pipes/filter-site-filter-items.pipe';
import { FilterTaskAssignedToPipe } from './pipes/filter-tasks-assigned-to.pipe';
import { FilterTaskEmployeePipe } from './pipes/filter-tasks-employee.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { SafeResourceUrlPipe } from './pipes/safe-resource-url.pipe';
import { FilterSelectOptionsPipe } from './pipes/select-option-filter.pipe';
import { FilterStringArrayPipe } from './pipes/string-array-filter.pipe';
import { StringToHtmlPipe } from './pipes/stringToHtml.pipe';
import { StripTagsPipe } from './pipes/strip-tags.pipe';
import { UserInitialsPipe } from './pipes/user-initials.pipe';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    RoleModule,
    SiteSettingsModule,
  ],
  declarations: [
    Base64DecodePipe,
    SafeHtmlPipe,
    SafeResourceUrlPipe,
    ArraySlicePipe,
    FilterDetailedUsersPipe,
    UserInitialsPipe,
    StripTagsPipe,
    AssessmentListItemComponent,
    FilterSiteItemsPipe,
    FilterTaskAssignedToPipe,
    FilterRecAssignedToPipe,
    FilterStringArrayPipe,
    FilterTaskEmployeePipe,
    FilterSelectOptionsPipe,
    UserSelectItemComponent,
    VarDirective,
    StringToHtmlPipe,
    FilterNotificationTemplatesPipe,
    UserNameLinkComponent,
    UserProfileDialogComponent,
    UserSelectComponent,
  ],
  exports: [
    Base64DecodePipe,
    SafeHtmlPipe,
    SafeResourceUrlPipe,
    ArraySlicePipe,
    FilterDetailedUsersPipe,
    UserInitialsPipe,
    StripTagsPipe,
    AssessmentListItemComponent,
    FilterSiteItemsPipe,
    FilterTaskAssignedToPipe,
    FilterRecAssignedToPipe,
    FilterTaskEmployeePipe,
    FilterStringArrayPipe,
    FilterSelectOptionsPipe,
    UserSelectItemComponent,
    VarDirective,
    StringToHtmlPipe,
    FilterNotificationTemplatesPipe,
    UserNameLinkComponent,
    UserProfileDialogComponent,
    UserSelectComponent,
  ],
  entryComponents: [
    UserProfileDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
